import { DescriptionSectionTypes } from '../types/shared/Challenge';
import WYSIWYG from '@pages/challengeGroups/challenge/WYSIWYG';
import Image from '@pages/challengeGroups/challenge/Image';
import Video from '@pages/challengeGroups/challenge/Video';
import Accordion from '@pages/challengeGroups/challenge/Accordion';

export const descriptionComponents = {
    [DescriptionSectionTypes.WYSIWYG]: WYSIWYG,
    [DescriptionSectionTypes.Image]: Image,
    [DescriptionSectionTypes.Video]: Video,
    [DescriptionSectionTypes.Accordion]: Accordion,
};
